export default {
  simulationDataIsMissing: 'Please fill material and select calculation model',
  errorMinLargerMax: 'min > max',
};
